import { Dialog } from "primereact/dialog";
import React from "react";
import { CalendarDays } from "lucide-react";
import { Divider } from "primereact/divider";

const ShowHolidayComponent = ({
  holidayData,
  setHolidayData,
  isViewHolidayData,
  setIsViewHolidayData,
}: any) => {
  const getDates = () => {
    const formatDate = (dateStr: any) => {
      return new Date(dateStr).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    };
    const startDateObj = holidayData?.startDate
      ? new Date(holidayData.startDate)
      : null;
    const endDateObj = holidayData?.endDate
      ? new Date(holidayData.endDate)
      : null;

    if (startDateObj && endDateObj) {
      const startDateStr = startDateObj.toISOString().split("T")[0];
      const endDateStr = endDateObj.toISOString().split("T")[0];
      if (startDateStr === endDateStr) {
        return formatDate(startDateObj);
      }
      return `${formatDate(startDateObj)} - ${formatDate(endDateObj)}`;
    }
    if (startDateObj) {
      return formatDate(startDateObj);
    }
    return "Date not available.";
  };

  return (
    <div>
      <Dialog
        header={
          <h2 className="tw-text-xl tw-font-bold tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <CalendarDays className="tw-text-blue-500" size={20} />
            Holiday Details
          </h2>
        }
        draggable={false}
        visible={isViewHolidayData}
        style={{ width: "100vw", maxWidth: 550 }}
        onHide={() => {
          setHolidayData(null);
          setIsViewHolidayData(false);
        }}
        className="tw-rounded-xl tw-bg-red-500"
      >
        <div className="tw-bg-white tw-border-red-500 tw-rounded-lg tw-shadow-md tw-p-6 tw-w-full">
          <div className="tw-space-y-4">
            <div className="tw-pb-4">
              {/* <h2 className="tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-mb-2 tw-text-black">
                Holiday Information
              </h2>
              <Divider
                align="center"
                className="tw-my-2 tw-bg-gray-200 tw-h-[2px]"
              /> */}
              <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-text-sm">
                <div className="tw-font-semibold tw-text-gray-900">Name:</div>
                <div className="tw-font-medium">{holidayData?.name ?? ""}</div>

                <div className="tw-font-semibold tw-text-gray-900">
                  Date Range:
                </div>
                <div className="tw-font-medium">{getDates()}</div>

                <div className="tw-font-semibold tw-text-gray-900">
                  Departments:
                </div>
              </div>
              <div className="tw-font-normal tw-flex tw-flex-wrap tw-gap-2 tw-mt-2">
                {holidayData?.department
                  .split(",")
                  .map((department: any, index: any) => (
                    <span
                      key={index}
                      className="tw-bg-blue-50 tw-text-blue-700 tw-border tw-border-blue-200 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold tw-shadow-sm tw-transition hover:tw-bg-blue-100"
                    >
                      {department.trim()}
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ShowHolidayComponent;
